import React from 'react';
import { Select, Empty, Card } from 'antd';
import TagWrap from './TagWrap'
import _ from 'lodash';
const Option = Select.Option;
import NoData from './NoData'

class TagSelect extends React.Component {

  render() {
    const { input: { value, onChange }, tags, loading } = this.props;
    return (
      <Select
        showSearch
        placeholder="请选择数据点"
        value={value || undefined}
        style={{ minWidth: 150 }}
        allowClear
        notFoundContent={<NoData />}
        onChange={onChange}
        loading={loading}
        filterOption={(input, option) => (
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
          option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
        )}
      >
        {(tags && tags.length > 0) ? tags.map(item => <Option value={item.id}>{item.name}</Option>) : <Card key="noData" disabled>
          <NoData></NoData>
        </Card>}
      </Select>
    );
  }
}

const TagSelectField = (props) => (
  <TagWrap nodeId={props.field.nodeId} modelId={props.field.modelId}>
    {state => <TagSelect {...props} {...state} />}
  </TagWrap>
)

export default TagSelectField;
